import { render, staticRenderFns } from "./NewAnchorAccessPoints.vue?vue&type=template&id=5442e298&scoped=true"
import script from "./NewAnchorAccessPoints.vue?vue&type=script&lang=js"
export * from "./NewAnchorAccessPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5442e298",
  null
  
)

export default component.exports